module.exports = __webpack_public_path__ + "img/thumb_23.da0c8803.jpg";